import { BlockEditProps } from "@wordpress/blocks";
import React from "react";
import type { BlockAttributes } from "./block.json";
import {
  InnerBlocks,
  InspectorControls,
  RichText,
  useBlockProps,
  useInnerBlocksProps,
} from "@wordpress/block-editor";
import ImageEditor from "../../../source/components/ImageEditor";
import {
  ToggleControl,
  PanelBody,
  PanelRow,
  TextControl,
} from "@wordpress/components";

const ALLOWED_BLOCKS = ["yellowtree/button", "core/heading", "core/paragraph"];

export default function CardEditor(props: BlockEditProps<BlockAttributes>) {
  const blockProps = useBlockProps({ className: "card-style-2" });
  const innerBlocksProps = useInnerBlocksProps(
    useBlockProps({
      className: "d-flex flex-wrap gap-3 swiper-slide",
    }) as unknown as Record<string, unknown>,
    {
      allowedBlocks: ALLOWED_BLOCKS,
      template: [["core/paragraph"], ["core/paragraph"], ["yellowtree/button"]],
    }
  );

  return (
    <>
      <div {...blockProps}>
        <div className="graphic-top bg-dark"></div>
        <div className="inner bg-dark">
          <div {...innerBlocksProps} />
        </div>

        <div className="graphic-bot bg-dark"></div>
      </div>
    </>
  );
}
